<template>
  <v-card min-height="1100px">
    <v-container fluid>
      <v-row>
        <v-spacer></v-spacer>
        <img v-if="settings && settings.logo_header_url" :src="settings.logo_header_url" alt="logo_img"/>
        <v-spacer></v-spacer>
      </v-row>
      <v-row class="margin-top-3">
        <v-spacer></v-spacer>
        <h1>{{ $t('subOrder.deliverySlip') }}</h1>
        <v-spacer></v-spacer>
      </v-row>
      <v-row class="margin-left-3 margin-top-3">
        <v-col v-if="subOrder.shipping_address" cols="6">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('order.shippingAddress') }}</v-list-item-title>
              <v-list-item-subtitle
                  v-if="subOrder.shipping_address.company">
                {{ subOrder.shipping_address.company }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ subOrder.shipping_address.first_name }} {{ subOrder.shipping_address.last_name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ subOrder.shipping_address.street_1.toUpperCase() }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.shipping_address.street_2">
                {{ subOrder.shipping_address.street_2.toUpperCase() }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ subOrder.shipping_address.postal_code }} {{ subOrder.shipping_address.city }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.shipping_address.country">
                {{ subOrder.shipping_address.country.name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.shipping_address.phone && (settings && settings.display_fields.phone)">
                {{ subOrder.shipping_address.phone }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.shipping_address.last_four_digit_phone_number">
                {{ subOrder.shipping_address.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col v-if="subOrder.billing_address && !subOrder.shipping_address" cols="6">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('order.billingAddress') }}</v-list-item-title>
              <v-list-item-subtitle
                v-if="subOrder.billing_address.company">
                {{ subOrder.billing_address.company }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ subOrder.billing_address.first_name }} {{ subOrder.billing_address.last_name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ subOrder.billing_address.street_1.toUpperCase() }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.billing_address.street_2">
                {{ subOrder.billing_address.street_2.toUpperCase() }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ subOrder.billing_address.postal_code }} {{ subOrder.billing_address.city }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.billing_address.country">
                {{ subOrder.billing_address.country.name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.billing_address.phone && (settings && settings.display_fields.phone)">
                {{ subOrder.billing_address.phone }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="subOrder.billing_address.last_four_digit_phone_number">
                {{ subOrder.billing_address.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="6">
          <v-list-item>
            <v-list-item-content>
              <template v-if="!subOrder.shipping_address && !subOrder.billing_address">
                <v-list-item-subtitle v-if='subOrder.customer.last_name && subOrder.customer.first_name'>
                  {{$t('order.customer')}}:  {{ subOrder.customer.first_name }} {{ subOrder.customer.last_name }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if='settings && settings.display_fields.phone && (subOrder.customer.phone || subOrder.customer.last_four_digit_phone_number)'>
                  {{ $t('order.phone') }}:  {{ subOrder.customer.phone || subOrder.customer.last_four_digit_phone_number }}
                </v-list-item-subtitle>
              </template>
              <v-list-item-subtitle v-if='settings && settings.display_fields.email && subOrder.customer.email'>
                Email: {{ subOrder.customer.email }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ $t('order.date') }}: {{ new Date(subOrder.date)| moment('DD/MM/YYYY HH:mm:ss') }}
              </v-list-item-subtitle>
              <v-list-item-subtitle> {{ $t('order.order') }} N° {{ subOrder.order_id }}</v-list-item-subtitle>
              <v-list-item-subtitle>TYPE: {{ getTypeTranslation(subOrder.type) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row v-if="settings && settings.display_fields.barcode">
        <v-col cols="12" style="display:flex; justify-content:center; width: 100%; padding:0px;" >
          <barcode :value="subOrder.order_id" width="1" height="90" font-size="15"/>
        </v-col>
      </v-row>
      <v-row class="margin-top-2">
        <v-col cols="12">
          <v-data-table
              :headers="tableHeaders"
              :hide-default-footer="true"
              :items="subOrder.items"
              :disable-sort="true"
              :expanded.sync="expanded"
              :single-expand="false"
              item-key='_id'
          >
            <template v-slot:item.product_title="{ item }">
              <p style="display:flex; justify-content: center">{{ item.product_title }}</p>
            </template>
            <template v-slot:item.ref="{ item }">
              <p v-if="item.product_id" style="display:flex; justify-content: center"> {{ item.product_id }}</p>
              <p v-if="!item.product_id && item.product_sku" style="display:flex; justify-content: center"> {{ item.product_sku }}</p>
              <p v-if="!item.product_id && (item.barcode || item.product_ean)" style="display:flex; justify-content: center"> {{ item.barcode || item.product_ean }}</p>
            </template>
            <template v-slot:item.product_sku="{ item }" >
              <p style="display:flex; justify-content: center"> {{ item.product_sku }}</p>
            </template>
            <template v-slot:item.details="{ item }">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle v-if="item.product_size" style="display:flex; justify-content: center; color:black;">{{ $t('product.size') }}: {{ item.product_size }}</v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.product_color" style="display:flex; justify-content: center; color:black;"> {{ $t('product.color') }}: {{ item.product_color }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item.validated_quantity="{ item }">
              <p style="display:flex; justify-content: center">{{ item.validated_quantity }}</p>
            </template>
            <template v-slot:expanded-item="{ item }">
              <td colspan="4">
                <p :key="indexCustom" v-for="(customization, indexCustom) of item.customizations" class="pt-0">
                  <span class="font-weight-bold" v-if="customization.display_label">
                    {{ customization.display_label }}:
                  </span>
                  <span class="font-weight-bold" v-else> {{ customization.custom_service_id }} </span>
                  <span
                    :key="indexProperty"
                    v-for="(property, indexProperty) of customization.properties"
                    style="white-space: normal;"
                  >
                    <span v-if="indexProperty !== 0">/</span><span style="text-transform: none;">{{ property.value }}</span>
                  </span>
                </p>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-footer v-if="settings && settings.footer_text"  absolute style="background: none">
        <v-col style="text-align: center">
          <span v-html="settings.footer_text" ></span>
        </v-col>
      </v-footer>
    </v-container>
  </v-card>
</template>
<script>

import VueBarcode from 'vue-barcode'

export default {
  name: 'SummaryPdf',
  components: {
    barcode: VueBarcode
  },
  data () {
    return {
      expanded: [],
      tableHeaders: [

      ],
      subOrderTypeTranslations: [
        { text: this.$t('subOrder.shipFromWarehouse'), value: 'ship_from_warehouse' },
        { text: this.$t('subOrder.clickAndCollect'), value: 'click_and_collect' },
        { text: this.$t('subOrder.inStorePickup'), value: 'in_store_pickup' },
        { text: this.$t('subOrder.shipFromStore'), value: 'ship_from_store' },
        { text: this.$t('subOrder.clickAndReserve'), value: 'click_and_reserve' },
        { text: this.$t('subOrder.interStore'), value: 'inter_store' }
      ],
      settings: null
    }
  },
  props: {
    subOrder: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.getSettings()
    if (this.subOrder) {
      for (let item of this.subOrder.items) {
        if (Array.isArray(item.customizations) && item.customizations.length) {
          this.expanded.push(item)
        }
      }
    }

    let haveSku = this.subOrder.items.some((item) => item.product_sku)

    this.tableHeaders = [
      {
        text: this.$t('product.product'),
        value: 'product_title'
      },
      {
        text: this.$t('product.ref'),
        value: 'ref'
      }
    ]
    if (haveSku) {
      this.tableHeaders.push({
          text: this.$t('product.sku'),
          value: 'product_sku'
        }
      )
    }

    const additionalHeaders = [
      { text: this.$t('product.details'), value: 'details' },
      { text: this.$t('product.validatedQuantity'), value: 'validated_quantity' }
    ]
    this.tableHeaders.push(...additionalHeaders)
  },
  methods: {
    getTypeTranslation: function (typeValue) {
      let type = this.subOrderTypeTranslations.find(type => type.value == typeValue)
      return type ? type.text : typeValue
    },
    getSettings: function () {
      let myInit = {
        headers: {
          'Authorization': 'Bearer ' + this.$auth.accessToken
        }
      }
      const countryCode = this.subOrder.shipping_address ? this.subOrder.shipping_address.country_code : 'FRA'
      this.$Amplify.API.get('settings', '/v1/settings/' + countryCode, myInit).then((res) => {

        if (res && res.delivery_slip) {
          this.settings = {}
          this.settings.logo_header_url = res.delivery_slip.logo_header_url
          this.settings.footer_text = res.delivery_slip.footer_text
          this.settings.display_fields = res.delivery_slip.display_fields
        }

      }).catch((e) => {
        //alert(e)
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>

.margin-top-3 {
  margin-top: 3em;
}

.margin-left-3 {
  margin-left: 3em;
}

img {
  max-height: 200px;
  max-width: 200px;
}
</style>
